import styled from "styled-components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { useMutation } from "@apollo/client";
import {
  InputPassword,
  InputSelect,
  InputText,
  ModalForm,
  // StatusFeedback,
} from "../../../components/form";
import {
  REGISTER_USER,
  UPDATE_USER,
  DELETE_USER,
} from "../../../services/auth";
import { useEffect, useState } from "react";
import { DeleteUserText } from "../StylesCatalogs";

const ModuleTitle = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
`;

export const ModalNewUser = ({
  companies,
  roles,
  statusList,
  setStatus,
  user,
  showModalDeleteUser,
  showModalEditUser,
  closeModal,
  getCatalogUsers,
  setCreatedUser,
  setUpdateUser,
  setDeleteUser,
}) => {
  const [inputPass, setInputPass] = useState("");
  const schema = yup.object({
    email: yup
      .string()
      .required("Ingresa un email valido")
      .email("Ingresa un email valido"),
    password: showModalEditUser
      ? inputPass !== "" &&
        yup
          .string("Ingresa una contraseña valida")
          .min(6, "Ingresa una contraseña valida")
      : yup
          .string("Ingresa una contraseña valida")
          .min(6, "Ingresa una contraseña valida"),
  });

  // Mutations
  const [doCreateUser, resultsCreateUser] = useMutation(REGISTER_USER, {
    onCompleted({ createUser }) {
      if (createUser.statusCode === 200) {
        closeModal();
        getCatalogUsers();
      } else {
        setCreatedUser({
          view: true,
          created: false,
          customMessage:
            "El usuario no pudo ser creado. El correo electrónico ya existe.",
        });
        console.log("error");
      }
    },
  });

  const [updateUser] = useMutation(UPDATE_USER, {
    onCompleted({ updateUser }) {
      if (updateUser.statusCode === 200) {
        setStatus("Success");
        closeModal();
        getCatalogUsers();
        setUpdateUser({ view: true, updated: true });
      } else {
        setStatus("Error");
      }
    },
    onError(error) {
      console.log("Error", error);
    },
  });

  const [deleteUser] = useMutation(DELETE_USER, {
    onCompleted({ deleteUser }) {
      if (deleteUser.statusCode === 200) {
        setStatus("Success");
        closeModal();
        getCatalogUsers();
        setDeleteUser({ view: true, deleted: true });
      } else {
        setStatus("Error");
      }
    },
    onError(error) {
      console.log("Error", error);
    },
  });

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const { handleSubmit: handleSubmitDelete } = useForm();

  // Manda un nuevo objeto solo con los datos fueron modificados en el form
  const compareObjects = (objOne, objTwo) => {
    const result = {};
    for (const key in objOne) {
      if (!objTwo.hasOwnProperty(key) || objOne[key] !== objTwo[key]) {
        result[key] = objOne[key];
      }
    }
    return result;
  };

  const onSubmit = (data) => {
    if (showModalDeleteUser) {
      const userId = { usuario_id: parseInt(user.usuario_id) };
      return deleteUser({ variables: userId });
    }

    const dataForSubmit = {
      email: data.email,
      password: data.password,
      rol_usuario_id: parseInt(data.rol),
      nombre_empresa: data.nombre_empresa,
      nombre: data.nombre,
      apellido: data.apellido,
    };

    if (showModalEditUser) {
      let newObject = dataForSubmit;
      newObject.usuario_id = parseInt(user.usuario_id);
      if (data.password === "") {
        // Descarta el password si está vacio
        newObject = Object.keys(newObject)
          .filter((key) => key !== "password")
          .reduce((acc, key) => ({ ...acc, [key]: newObject[key] }), {});
      }
      const objectValidated = compareObjects(newObject, user);
      // si no se ha actualizado algún campo no se aplica ningun cambio
      if (Object.keys(objectValidated).length > 1) {
        return updateUser({ variables: objectValidated });
      } else {
        return;
      }
    }
    doCreateUser({ variables: dataForSubmit });
  };

  const [rolesDefault, setRolesDefault] = useState(roles[0].value);
  const [empresasDefault, setEmpresasDefault] = useState(companies[0].value);

  useEffect(() => {
    if (user && showModalEditUser) {
      setRolesDefault(user?.rol_usuario_id);
      setEmpresasDefault(user?.empresa);
      reset({
        email: user.email,
        nombre: user.nombre,
        apellido: user.apellido,
        nombre_empresa: user.nombre_empresa,
      });
    } else {
      reset({
        email: "",
        password: "",
        nombre: "",
        apellido: "",
      });
      setRolesDefault(null);
      setEmpresasDefault(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (resultsCreateUser.data) {
      if (resultsCreateUser?.data?.createUser?.statusCode === 200) {
        setCreatedUser({ view: true, created: true });
        setStatus("Success");
        reset({
          email: "",
          password: "",
          rol: "",
          nombre: "",
          apellido: "",
        });
      } else {
        setStatus("Error");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resultsCreateUser]);

  const title = showModalEditUser
    ? "Editar usuario"
    : "Agrega un usuario nuevo";

  return showModalDeleteUser ? (
    <>
      <ModuleTitle style={{ textAlign: "center", marginBottom: "12px" }}>
        ¿Estás seguro de que deseas eliminar este usuario?
      </ModuleTitle>
      <ModalForm
        title="¿Estás seguro de que deseas eliminar este usuario"
        textButton="Sí, eliminar este usuario"
        handleSubmitRef={handleSubmitDelete(onSubmit)}
      >
        <DeleteUserText>Este cambio es permanente</DeleteUserText>
      </ModalForm>
    </>
  ) : (
    <>
      <ModuleTitle style={{ textAlign: "center", marginBottom: "12px" }}>
        {title}
      </ModuleTitle>
      <ModalForm
        title="Agrega un usuario nuevo"
        textButton={showModalEditUser ? "Editar usuario" : "Agregar usuario"}
        handleSubmitRef={handleSubmit(onSubmit)}
      >
        <InputText
          label="Nombre"
          name="nombre"
          type="text"
          control={control}
          placeholder="Nombre del usuario"
          register={{ ...register("nombre") }}
          errorMessage={errors.nombre?.type}
        />
        <InputText
          label="Apellido"
          name="apellido"
          type="text"
          control={control}
          placeholder="Apellido del usuario"
          register={{ ...register("apellido") }}
          errorMessage={errors.apellido?.type}
        />
        <InputSelect
          label="Nombre de empresa"
          name="nombre_empresa"
          options={companies}
          control={control}
          defaultValue={empresasDefault}
          setDefaultValue={setEmpresasDefault}
          errorMessage={errors.rol?.message}
          placeholder="empresas"
        />
        <InputText
          label="Correo electrónico"
          type="email"
          placeholder="Correo electrónico"
          register={{ ...register("email") }}
          errorMessage={errors.email?.message}
        />
        <InputSelect
          label="Rol de usuario"
          name="rol"
          options={roles}
          control={control}
          defaultValue={rolesDefault}
          setDefaultValue={setRolesDefault}
          errorMessage={errors.rol?.message}
          placeholder="Rol del usuario"
        />
        <InputPassword
          label="Ingresa una contraseña"
          type="password"
          placeholder="Contraseña"
          onChange={(e) => setInputPass(e.target.value)}
          register={{ ...register("password") }}
          errorMessage={errors.password?.message}
        />
        {/* <StatusFeedback
          status={statusList}
          errorMessage="El usuario no pudo ser creado. El correo electrónico ya existe."
          successMessage={textSuccesMessage}
        /> */}
      </ModalForm>
    </>
  );
};
